import styled from "styled-components";
import { Heading } from "../../common/Heading/Heading";
import { useTranslation } from "react-i18next";
import { media } from "../../../styles/mixins";
import { COLORS } from "../../../assets/constants/styles";
import { LightningIcon } from "../../../assets/images/LightningIcon";
import { TIcon } from "../../../assets/images/TIcon";
import { ExclamationIcon } from "../../../assets/images/ExclamationIcon";
import { HeartIcon } from "../../../assets/images/HeartIcon";

export const Reasons = () => {
  const { t } = useTranslation();

  const reasonIcons = [
    <LightningIcon />,
    <TIcon />,
    <ExclamationIcon />,
    <HeartIcon />,
  ];

  return (
    <ReasonsComponentContainer id="benefits">
      <TitleContainer>
        <Heading size={1} text={t("reasons.title")} />
        <Caption> {t("reasons.caption")}</Caption>
      </TitleContainer>
      <ReasonsContainer>
        {reasonIcons.map((icon, index) => {
          return (
            <ReasonContainer key={`reason-icon-${index}`}>
              <IconContainer>{icon}</IconContainer>
              <Heading size={2} text={t(`reasons.reasonText.${index}.title`)} />
              <ReasonCaption>
                {t(`reasons.reasonText.${index}.caption`)}
              </ReasonCaption>
            </ReasonContainer>
          );
        })}
      </ReasonsContainer>
    </ReasonsComponentContainer>
  );
};

const ReasonsComponentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 37px;
  margin-bottom: 32px;

  text-align: center;

  ${media.tablet(`
    margin-top: 58px;
     margin-bottom: 40px;
  `)}

  ${media.laptop(`
    margin-top: 80px;
    margin-bottom: 70px;
  `)}
`;

const ReasonsContainer = styled.div`
  display: grid;
  width: 100%;
  grid-row-gap: 32px;
  grid-template-columns: auto;

  ${media.tablet(`
     grid-row-gap: 48px;
    grid-template-columns: 1fr 1fr;

  `)};
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;

  ${media.tablet(`
     margin-bottom: 40px;
  `)}

  ${media.laptop(`
    margin-bottom: 70px;
  `)}
`;

const Caption = styled.div`
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${COLORS.grey};

  margin-top: 16px;

  ${media.tablet(`
     margin-top: 28px;
  `)}
`;

const ReasonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify:content:center;
  align-items:center;
`;

const IconContainer = styled.div`
  margin-bottom: 16px;

  ${media.tablet(`
  margin-top: 24px;
  `)};
`;

const ReasonCaption = styled.div`
  font-size: 16px;
  line-height: 150%;

  letter-spacing: -0.005em;

  color: ${COLORS.grey};
`;
